import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getSales = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Sales/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales:", error);
    throw error;
  }
};

export const saveSales = async (sales) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Sales/save`, sales, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error saving sales:", error);
    throw error;
  }
};

export const exportSalesToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Sales/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SalesbookReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting sales:", error);
    throw error;
  }
}; 